import { ImagesMobile } from '@/assets/images';
import { findPosition } from '@/utils';
import {
	Children,
	memo,
	useCallback,
	useEffect,
	useRef,
	useState,
} from 'react';

import { isArray } from 'ramda-adjunct';

import { ContainerPdfProps } from './container-pdf.type';

const ContainerPdfMobile = (props: ContainerPdfProps) => {
	const { children, pageRefs } = props;

	const [page, setPage] = useState('1');

	const containerRef = useRef<HTMLDivElement>(null);

	const count = Children.count(children);

	const handleScroll = useCallback(() => {
		const arrayOffset =
			(isArray(pageRefs?.current) &&
				pageRefs?.current?.map(
					(item) => (item as HTMLDivElement)?.offsetTop
				)) ||
			[];

		const { scrollTop, clientHeight } = containerRef.current as HTMLDivElement;
		const containerBottom = scrollTop === 0 ? 400 : scrollTop + clientHeight;

		const pageViewport = findPosition(arrayOffset, containerBottom);
		setPage(pageViewport.toLocaleString());
	}, [children, pageRefs?.current]);

	useEffect(() => {
		if (containerRef && children) {
			containerRef.current?.addEventListener('scroll', handleScroll);
		}

		return () => {
			containerRef.current?.removeEventListener('scroll', handleScroll);
		};
	}, [containerRef.current, children]);

	// useEffect(() => {
	// 	(async () => {
	// 		if (pageRefs?.current.length) {
	// 			requestAnimationFrame(async () => {
	// 				const filePdf = await printDocument(
	// 					pageRefs?.current || [],
	// 					fileName
	// 				);
	// 				setInitFile(filePdf);
	// 			});
	// 		}
	// 	})();
	// }, []);

	return (
		<>
			<div className="absolute left-[12px] top-[12px] z-10">
				<div className="flex justify-center items-center gap-2 bg-rgbaModal rounded-[4px] px-[6px] py-[2px]">
					<img
						src={ImagesMobile.iconPagePreview}
						alt=""
						className="w-[24px] [h-[24px]"
					/>
					<span className="text-[13px] font-normal text-white">
						{page}/{count}
					</span>
				</div>
			</div>
			<div className="overflow-auto h-[calc(100vh_-_110px)]" ref={containerRef}>
				{children}
			</div>
		</>
	);
};

export default memo(ContainerPdfMobile);
